import React, { useState } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars

const FocusBehavior = props => {
  const [hasFocus, setHasFocus] = useState(false);

  const handleFocus = event => {
    if (props.onFocus) {
      props.onFocus(event);
    }

    if (!event.defaultPrevented) {
      setHasFocus(true);
    }
  };

  const handleBlur = event => {
    if (props.onBlur) {
      props.onBlur(event);
    }

    if (!event.defaultPrevented) {
      setHasFocus(false);
    }
  };

  return props.children({
    hasFocus,
    onFocus: handleFocus,
    onBlur: handleBlur
  });
};

FocusBehavior.propTypes = {
  children: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

// eslint-disable-next-line no-unused-vars

const HoverBehavior = props => {
  const [hasHover, setHasHover] = useState(false);

  const handleFocus = event => {
    if (props.onMouseEnter) {
      props.onMouseEnter(event);
    }

    if (!event.defaultPrevented) {
      setHasHover(true);
    }
  };

  const handleBlur = event => {
    if (props.onMouseLeave) {
      props.onMouseLeave(event);
    }

    if (!event.defaultPrevented) {
      setHasHover(false);
    }
  };

  return props.children({
    hasHover,
    onMouseEnter: handleFocus,
    onMouseLeave: handleBlur
  });
};

HoverBehavior.displayName = "HoverBehavior";
HoverBehavior.propTypes = {
  children: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};

const PressedBehavior = props => {
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = event => {
    if (props.onMouseDown) {
      props.onMouseDown(event);
    }

    if (!event.defaultPrevented) {
      setIsPressed(true);
    }
  };

  const handleMouseLeave = event => {
    if (props.onMouseLeave) {
      props.onMouseLeave(event);
    }

    if (!event.defaultPrevented) {
      setIsPressed(false);
    }
  };

  const handleMouseUp = event => {
    if (props.onMouseUp) {
      props.onMouseUp(event);
    }

    if (!event.defaultPrevented) {
      setIsPressed(false);
    }
  };

  return props.children({
    isPressed,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onPressedMouseLeave: handleMouseLeave
  });
};

PressedBehavior.displayName = "PressedBehavior";
PressedBehavior.propTypes = {
  children: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseUp: PropTypes.func
};

const ControlBehavior = props => /*#__PURE__*/React.createElement(HoverBehavior, {
  onMouseEnter: props.onMouseEnter,
  onMouseLeave: props.onMouseLeave
}, _ref => {
  let {
    hasHover,
    onMouseEnter,
    onMouseLeave
  } = _ref;
  return /*#__PURE__*/React.createElement(FocusBehavior, {
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }, _ref2 => {
    let {
      hasFocus,
      onFocus,
      onBlur
    } = _ref2;
    return /*#__PURE__*/React.createElement(PressedBehavior, {
      onMouseDown: props.onMouseDown,
      onMouseUp: props.onMouseUp,
      onMouseLeave: onMouseLeave
    }, _ref3 => {
      let {
        isPressed,
        onMouseDown,
        onMouseUp,
        onPressedMouseLeave
      } = _ref3;
      return props.children({
        hasHover,
        hasFocus,
        isPressed,
        onFocus,
        onBlur,
        onMouseDown,
        onMouseEnter,
        onMouseLeave: onPressedMouseLeave,
        onMouseUp
      });
    });
  });
});

ControlBehavior.displayName = "ControlBehavior";
ControlBehavior.propTypes = {
  children: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseUp: PropTypes.func
};
ControlBehavior.__docgenInfo = {
  "description": "",
  "displayName": "ControlBehavior",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

export { ControlBehavior, FocusBehavior, HoverBehavior, PressedBehavior };
